import styled from "styled-components";

export const Container = styled.main(({ expanded }) => ({
  position: "relative",
  overflow: "hidden",
  display: "flex",
  flexDirection: "column",
  flex: "1",
  transition: "all .15s",
  padding: "0 0px"
  //marginLeft: expanded ? "240px" : "64px"
}));
